import { AudienceId } from "@sp-crm/core";
import { Icon } from "components/icon";
import React from "react";
import { Link } from "react-router-dom";

interface AudienceLinkProps {
    audience: { id: AudienceId; name: string } | null;
    emptyLabel?: string;
}

export const AudienceLink: React.FC<AudienceLinkProps> = props => {
    const { audience } = props;

    const emptyLabel = props.emptyLabel ?? "(deleted contact list)";

    if (!audience) return <p>{emptyLabel}</p>;

    return (
        <Link
            to={`/settings/integrations/mailchimp/audiences/${audience.id}`}
            className="inline-block">
            <div className="flex items-center space-x-1">
                <div className="w-4">
                    <Icon name="51_Staff" />
                </div>
                <p>{audience.name}</p>
            </div>
        </Link>
    );
};
